import AllRoutes from "./components/AllRoutes";

function App() {
  return (
    <>
      <AllRoutes />
    </>
  );
}

export default App;
